import { View } from 'react-big-calendar';
import { SlotCombination, SlotLabels } from '../resources/providerCalendar';

export const CALENDAR_VIEWS: View[] = ['month', 'week', 'day'];

export const generateCustomTimeRanges = () => {
  return {
    morning: [
      { label: SlotLabels.MORNING_FIRST, from: '00:00', to: '07:59' },
      { label: SlotLabels.MORNING_SECOND, from: '15:00', to: '23:59' },
    ],
    afternoon: [
      { label: SlotLabels.AFTERNOON_FIRST, from: '00:00', to: '12:59' },
      { label: SlotLabels.AFTERNOON_SECOND, from: '20:00', to: '23:59' },
    ],
    night: [
      { label: SlotLabels.NIGHT_FIRST, from: '08:00', to: '19:59' },
      { label: SlotLabels.NIGHT_SECOND, from: '00:00', to: '07:59' },
    ],
    fullDay: [
      { label: SlotLabels.FULL_DAY_FIRST, from: '00:00', to: '07:59' },
      { label: SlotLabels.FULL_DAY_SECOND, from: '20:00', to: '23:59' },
    ],
    Off: [{ label: '', from: '00:00', to: '23:59' }],
  };
};

export const slotCombinationLabel = (slotJson: { from_slot: string; to_slot: string }[]) => {
  const sorted = [...slotJson].sort((a, b) => a.from_slot.localeCompare(b.from_slot));
  const key = sorted.map((s) => `${s.from_slot}-${s.to_slot}`).join(',');

  const labelMap: Record<string, { title: string; SecondTitle: string }> = {
    '00:00-07:59,15:00-23:59': {
      title: '8AM - 3PM',
      SecondTitle: 'Morning',
    },
    '00:00-12:59,20:00-23:59': {
      title: '1PM - 8PM',
      SecondTitle: 'Afternoon',
    },
    '00:00-07:59,08:00-19:59': {
      title: '8PM - 8AM',
      SecondTitle: 'Night',
    },
    '08:00-19:59': {
      title: '8PM - 8AM',
      SecondTitle: 'Night',
    },
    '00:00-07:59,20:00-23:59': {
      title: '8AM - 8PM',
      SecondTitle: 'Full Day',
    },
    '00:00-23:59': {
      title: '12AM - 11:59PM',
      SecondTitle: 'Off',
    },
  };

  return (
    labelMap[key] || {
      title: '',
      SecondTitle: '',
    }
  );
};

export const SlotLabelCombination = {
  [SlotCombination.MORNING]: {
    first: 'Morning First Slot',
    second: 'Morning Second Slot',
  },
  [SlotCombination.AFTERNOON]: {
    first: 'Afternoon First Slot',
    second: 'Afternoon Second Slot',
  },
  [SlotCombination.NIGHT]: {
    first: 'Night First Slot',
    second: 'Night Second Slot',
  },
  [SlotCombination.FULL_DAY]: {
    first: 'Full Day First Slot',
    second: 'Full Day Second Slot',
  },
};
